import { render, staticRenderFns } from "./flooter.vue?vue&type=template&id=2069c236&scoped=true&"
import script from "./flooter.vue?vue&type=script&lang=js&"
export * from "./flooter.vue?vue&type=script&lang=js&"
import style0 from "./flooter.vue?vue&type=style&index=0&id=2069c236&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2069c236",
  null
  
)

export default component.exports